import type { IconButtonProps } from "@mui/material";
import { IconButton } from "@mui/material";
import type { FC, ReactNode } from "react";

interface Props extends IconButtonProps {
  icon: ReactNode;
}

export const ActionButton: FC<Props> = ({ icon, ...props }) => {
  return <IconButton {...props}>{icon}</IconButton>;
};
